import { createFileRoute } from '@tanstack/react-router'
import { ContactDetailPage } from '@/pages/contact-detail'

export const Route = createFileRoute('/_authenticated/contacts/$contactId')({
  staticData: { title: 'Contact' },
  component: ContactDetailRoute,
})

function ContactDetailRoute() {
  const { contactId } = Route.useParams()
  return <ContactDetailPage contactId={Number(contactId)} />
}
